import React, { use } from 'react'
import { useEffect, useState } from 'react'
import ShareMenu from './ShareMenu'
import '../App.css'

export default function Sparkling({
    isJustLoaded,
    shouldRender,
    menuOpen,
    theme,
    setMenuOpen,
    darkColor,
    fontMapBold,
    headerText,
    wineData,
    fontMapReg,
    bodyText,
    imageBase,
    imageType,
    wineryLogo,
    matches,
    tastingText,
    userFlavorData,
    userAcidity,
    barColor,
    userSweetness,
    lightColor,
    wineProfileData,
    wineFlavors,
    qrData,
    iconQRIMGID,
    QR,
    Share,
    wineAcidity,
    wineSweetness,
    sparklingData, 
    sparklingOwner, 
    sparklingTheme, 
    userSparklingFlavor,
    effervescence, 
    sparklingWineProfile, 
    sparklingFlavor, 
    sparklingQR, 
    sparklingIconIDS, 
    sparklingHeaderText, 
    sparklingBodyText
}) {

    const [sparklingLogo, setSparklingLogo] = useState('');
    const [sparklingWineFlavors, setSparklingWineFlavors] = useState([]);

    const acidityPercent = sparklingWineProfile?.data?.acidity * 100;
    const sweetnessPercent = sparklingWineProfile?.data?.sweetness * 100;
    const effervescencePercent = sparklingWineProfile?.data?.effervescence * 100;

    useEffect(() => {

        if (sparklingOwner) {   
            const ownerEndpoint = process.env.REACT_APP_OWNER;
            const authToken = process.env.REACT_APP_AUTH_TOKEN;
            const fetchOwnerLogo = async () => {
                try {
                    const response = await fetch(`${ownerEndpoint}`, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${authToken}`,
                            'Content-Type': 'application/json'
                        }
                    });
                    const ownerData = await response.json();
                    console.log('Owner Data:', ownerData);
                    const currentOwner = ownerData?.data.find(item => item.user_created === sparklingOwner);
                    const logo = currentOwner.logo;
                    setSparklingLogo(logo);
                } catch (error) {
                    console.error('Error fetching owner logo:', error);
                }
            };
            fetchOwnerLogo();
        }

    }, [sparklingOwner]);

  return (
    <div>
        <div className={'top-div'}>
         <div className='mobile-container'>
            {shouldRender && (
              <ShareMenu
                menuOpen={menuOpen}
                theme={theme}
                setMenuOpen={setMenuOpen}
                sparklingTheme={sparklingTheme}
              />
            )}
            <div className='wine-title-div' style={{ backgroundColor: darkColor[sparklingData?.data?.theme] }}>
              <h1 className='wine-title' style={{ fontFamily: fontMapBold[sparklingHeaderText] }}>{sparklingData?.data?.name}</h1>
              <p className="year" style={{ fontFamily: fontMapReg[sparklingBodyText] }}>{sparklingData?.data?.year}</p>
            </div>
            <div className='big-wine-container'>
              <img className='wine-image' src={`${imageBase}${sparklingData?.data?.bottle_image}${imageType}`} alt="Wine bottle" />
              <img src={`${imageBase}${sparklingLogo}${imageType}`} className='wine-logo'></img>
            </div>
            <div className='content-div'>
             <div className='right-col'>
              <div className='top-right' style={{ backgroundColor: darkColor[sparklingData?.data?.theme] }}>
                <h2 className='my-profile-header' style={{ fontFamily: fontMapBold[sparklingHeaderText] }}>My Tasting Profile</h2>
                <p className="user-profile" style={{ fontFamily: fontMapReg[sparklingBodyText] }}>
                   {matches === null || matches === 0 ? tastingText.no_match_text : matches === 1 || matches === 2 ? tastingText.low_match_text
                     : tastingText.high_match_text}
                </p>
                <h3 className='flavors-header' style={{ fontFamily: fontMapBold[sparklingHeaderText] }}>Flavors</h3>
                <div className='flavors-container top'>
                    {userSparklingFlavor?.data?.slice(0, 3).map(item => (
                       <div className='flavor-box' >
                         <div className='flav-img-container' style={{ backgroundColor: item.highlight_color }}>
                           <img
                             className='user-flavor-img'
                             key={item.id}
                             src={`${imageBase}${item.image}${imageType}`}
                             alt={`Flavor ${item.Flavors_id}`}
                           />
                         </div>
                         <p className='flavor-title' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>{item.name}</p>
                       </div>
                    ))}
                </div>
                {userSparklingFlavor?.data?.length > 3 && (
                     <div className='flavors-container bottom'>
                       {userSparklingFlavor?.data?.slice(3, 5).map(item => (
                         <div className='flavor-box' key={item.id}>
                           <div className='flav-img-container' style={{ backgroundColor: item.highlight_color }}>
                             <img
                               className='user-flavor-img'
                               src={`${imageBase}${item.image}${imageType}`}
                               alt={`Flavor ${item.Flavors_id}`}
                             />
                           </div>
                           <p className='flavor-title' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>{item.name}</p>
                         </div>
                       ))}
                     </div>
                   )}
                <div className='acid-sweetness-columns'>
                   <div className='acidity-col'>
                     <h4 className='acidity-header' style={{ fontFamily: fontMapBold[sparklingHeaderText] }}>Acidity</h4>
                     <div className='acidity-bar'>
                       <div style={{
                         height: '65%',
                         width: `${userAcidity}%`,
                         backgroundColor: barColor[sparklingData?.data?.theme],
                         borderRadius: '15vw',
                         marginLeft: '3.5%',
                         marginRight: '3.5%'
                       }}>
                       </div>
                     </div>
                     <div className='acid-label-columns'>
                       <div className='l-acid-col'>
                         <p className='low-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>Low</p>
                       </div>
                       <div className='r-acid-col'>
                         <p className='high-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>High</p>
                       </div>
                     </div>
                   </div>
                   <div className='sweetness-col'>
                     <h4 className='acidity-header' style={{ fontFamily: fontMapBold[sparklingHeaderText] }}>Sweetness</h4>
                     <div className='sweetness-bar'>
                       <div style={{
                         height: '65%',
                         width: `${userSweetness}%`,
                         backgroundColor: barColor[sparklingData?.data?.theme],
                         borderRadius: '15vw',
                         marginLeft: '3%',
                         marginRight: '3%'
                       }}>
                       </div>
                     </div>
                     <div className='acid-label-columns'>
                       <div className='l-acid-col'>
                         <p className='low-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>Dry</p>
                       </div>
                       <div className='r-acid-col'>
                         <p className='high-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>Very Sweet</p>
                       </div>
                     </div>
                   </div>
                 </div>
                 <div className='acid-sweetness-columns'>
                   <div className='acidity-col'>
                     <h4 className='acidity-header' style={{ fontFamily: fontMapBold[sparklingHeaderText] }}>Effervescence</h4>
                     <div className='acidity-bar'>
                       <div style={{
                         height: '65%',
                         width: `${effervescence}%`,
                         backgroundColor: barColor[sparklingData?.data?.theme],
                         borderRadius: '15vw',
                         marginLeft: '3%',
                         marginRight: '3%'
                       }}>
                       </div>
                     </div>
                     <div className='acid-label-columns'>
                       <div className='l-acid-col'>
                         <p className='low-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>Low</p>
                       </div>
                       <div className='r-acid-col'>
                         <p className='high-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>High</p>
                       </div>
                     </div> 
                   </div>
                 </div>
              </div>
              <div className='bottom-right' style={{ backgroundColor: lightColor[sparklingData?.data?.theme] }}>
                <h2 className='my-profile-header' style={{ fontFamily: fontMapBold[sparklingBodyText] }}>{sparklingData?.data?.name} Profile</h2>
                <p className="user-profile" style={{ fontFamily: fontMapReg[sparklingBodyText] }}>{sparklingWineProfile?.data?.description}</p>
                <h3 className='flavors-header' style={{ fontFamily: fontMapBold[sparklingHeaderText] }}>Flavors</h3>
                <div className='flavors-container top'>
                    {sparklingFlavor?.data?.slice(0, 3).map(item => (
                       <div className='flavor-box' >
                         <div className='flav-img-container' style={{ backgroundColor: item.highlight_color }}>
                           <img
                             className='user-flavor-img'
                             key={item.id}
                             src={`${imageBase}${item.image}${imageType}`}
                             alt={`Flavor ${item.Flavors_id}`}
                           />
                         </div>
                         <p className='flavor-title' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>{item.name}</p>
                       </div>
                     ))}
                   </div>
                   {sparklingFlavor?.data?.length > 3 && (
                <div className='flavors-container bottom'>
                {sparklingFlavor?.data.slice(3, 5).map(item => (
                    <div className='flavor-box' key={item.id}>
                        <div className='flav-img-container' style={{ backgroundColor: item.highlight_color }}>
                            <img
                               className='user-flavor-img'
                               src={`${imageBase}${item.image}${imageType}`}
                               alt={`Flavor ${item.Flavors_id}`}
                            />
                        </div>
                           <p className='flavor-title' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>{item.name}</p>
                         </div>
                    ))}
                </div>
                )}
                <div className='acid-sweetness-columns'>
                     <div className='acidity-col'>
                       <h4 className='acidity-header' style={{ fontFamily: fontMapBold[sparklingHeaderText] }}>Acidity</h4>
                       <div className='acidity-bar'>
                         <div style={{
                           height: '55%',
                           width: `${acidityPercent}%`,
                           backgroundColor: barColor[sparklingData?.data?.theme],
                           borderRadius: '15vw',
                           marginLeft: '3.5%',
                           marginRight: '3.5%'
                         }}>
                         </div>
                       </div>
                       <div className='acid-label-columns'>
                         <div className='l-acid-col'>
                           <p className='low-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>Low</p>
                         </div>
                         <div className='r-acid-col'>
                           <p className='high-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>High</p>
                         </div>
                       </div>
                     </div>
                     <div className='sweetness-col'>
                       <h4 className='acidity-header' style={{ fontFamily: fontMapBold[sparklingHeaderText] }}>Sweetness</h4>
                       <div className='sweetness-bar'>
                         <div style={{
                           height: '55%',
                           width: `${sweetnessPercent}%`,
                           backgroundColor: barColor[sparklingData?.data?.theme],
                           borderRadius: '15vw',
                           marginLeft: '3.5%',
                           marginRight: '3.5%'
                         }}>
                         </div>
                       </div>
                       <div className='acid-label-columns'>
                         <div className='l-acid-col'>
                           <p className='low-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>Dry</p>
                         </div>
                         <div className='r-acid-col'>
                           <p className='high-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>Very Sweet</p>
                         </div>
                       </div>
                     </div>
                   </div>
                   <div className='acid-sweetness-columns'>
                   <div className='acidity-col'>
                     <h4 className='acidity-header' style={{ fontFamily: fontMapBold[sparklingHeaderText] }}>Effervescence</h4>
                     <div className='acidity-bar'>
                       <div style={{
                         height: '55%',
                         width: `${effervescencePercent}%`,
                         backgroundColor: barColor[sparklingData?.data?.theme],
                         borderRadius: '15vw',
                         marginLeft: '3.5%',
                         marginRight: '3.5%'
                       }}>
                       </div>
                     </div>
                     <div className='acid-label-columns'>
                       <div className='l-acid-col'>
                         <p className='low-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>Low</p>
                       </div>
                       <div className='r-acid-col'>
                         <p className='high-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>High</p>
                       </div>
                     </div> 
                   </div>
                 </div>
              </div> 
              <div className='qr-code-section sparkling-qr-mobile' style={{ backgroundColor: lightColor[sparklingData?.data?.theme] }} >
                 <button className='share-link' onClick={() => setMenuOpen(true)}>
                   <img className='share-img' alt='share-icon' src={Share}></img>
                   <p className='share-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>Share your <br />Experience</p>
                 </button>


                 {sparklingQR?.data.map((item, index) => {
                   const iconId = sparklingIconIDS?.[index]; // Get the corresponding image ID

                   const imageSrc = iconId && String(iconId).length >= 3
                     ? `${process.env.REACT_APP_IMAGE_ENDPOINT}${iconId}${process.env.REACT_APP_IMAGE_TYPE}`
                     : QR; // Use QR as fallback


                   return (
                     <button
                       className='share-link'
                       key={item.id}
                       onClick={() => window.open(item.url, '_blank', 'noopener,noreferrer')}
                     >
                       <img
                         className='share-img'
                         src={imageSrc}
                         alt={`Flavor ${item.Flavors_id}`}
                       />
                       <p className='share-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>{item.label}</p>
                     </button>
                   );
                 })}
               </div> 
             </div>
            </div>
         </div>


         {/* Desktop */}
         <div className='desktop-container'>
           <div className='large-wine-container large-sparkling-container' style={{ backgroundColor: lightColor[sparklingData?.data?.theme] }}>
             <img className='wine-img' alt='Wine Bottle' src={`${imageBase}${sparklingData?.data?.bottle_image}${imageType}`}></img>
           </div>
           <div className='header' style={{ backgroundColor: darkColor[sparklingData?.data?.theme] }}>
             <div className='qr-code-section'>
               <button
                 onClick={() => setMenuOpen(true)}
                 className='share-link'
               >
                 <img className='share-img' alt='share-icon' src={Share}></img>
                 <p className='share-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>Share your <br />Experience</p>
               </button>
               {sparklingQR?.data?.map((item, index) => {
                 const iconId = sparklingIconIDS?.[index]; // Get the corresponding image ID

                 const imageSrc = iconId
                   ? `${process.env.REACT_APP_IMAGE_ENDPOINT}${iconId}${process.env.REACT_APP_IMAGE_TYPE}`
                   : QR; // Use QR as fallback

                 return (
                   <button
                     className='share-link'
                     key={item.id}
                     onClick={() => window.open(item.url, '_blank', 'noopener,noreferrer')}
                   >
                     <img
                       className='share-img'
                       src={imageSrc}
                       alt={`Flavor ${item.Flavors_id}`}
                     />
                     <p className='share-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>{item.label}</p>
                   </button>
                 );
               })}
             </div>
             <div className='logo-desk-container'>
               <img
                 src={`${imageBase}${sparklingLogo ? sparklingLogo : ''}${imageType}`}
                 className='wine-logo'
                 alt=''
               ></img>
             </div>
            </div>
            {shouldRender && (
                         <ShareMenu
                           menuOpen={menuOpen}
                           theme={theme}
                           setMenuOpen={setMenuOpen}
                           sparklingTheme={sparklingTheme}
                         />
            )}
            <div className='content sparkling-content' style={{ backgroundColor: lightColor[sparklingData?.data?.theme] }}>
            <div className='name-div'>
               <h1 className='wine-title' style={{ fontFamily: fontMapBold[sparklingHeaderText] }}>{sparklingData?.data?.name} <span style={{ fontFamily: fontMapReg[sparklingHeaderText] }} className='wine-year'>{sparklingData?.data?.year}</span></h1> 
            </div>
            <div className='flavor-columns'>
               <div className='l-col'>
                 <div className='profile-container'>
                   <h2 className='my-profile-header' style={{ fontFamily: fontMapBold[sparklingHeaderText] }}>My Tasting Profile</h2>
                   <p className="user-profile" style={{ fontFamily: fontMapReg[sparklingBodyText] }}>
                     {matches === null || matches === 0 ? tastingText.no_match_text : matches === 1 || matches === 2 ? tastingText.low_match_text
                       : tastingText.high_match_text}
                   </p>
                 </div>
                 <h3 className='flavors-header' style={{ fontFamily: fontMapBold[sparklingHeaderText] }}>Flavors</h3>
                 <div>
                   <div className='flavors-container top'>
                     {userSparklingFlavor?.data?.map(item => (
                       <div className='flavor-box' >
                         <div className='flav-img-container' style={{ backgroundColor: item.highlight_color }}>
                           <img
                             className='user-flavor-img'
                             key={item.id}
                             src={`${imageBase}${item.image}${imageType}`}
                             alt={`Flavor ${item.Flavors_id}`}
                           />
                         </div>
                         <p className='flavor-title sparkling-flavor-title' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>{item.name}</p>
                       </div>
                     ))}
                   </div>
                   <div className='acid-sweetness-columns'>
                     <div className='acidity-col'>
                       <h4 className='acidity-header' style={{ fontFamily: fontMapBold[sparklingHeaderText] }}>Acidity</h4>
                       <div className='acidity-bar'>
                         <div style={{
                           height: '55%',
                           width: `${userAcidity}%`,
                           backgroundColor: barColor[sparklingData?.data?.theme],
                           borderRadius: '20vw',
                           marginLeft: '3%',
                           marginRight: '3%',
                         }}>
                         </div>
                       </div>
                       <div className='acid-label-columns'>
                         <div className='l-acid-col'>
                           <p className='low-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>Low</p>
                         </div>
                         <div className='r-acid-col'>
                           <p className='high-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>High</p>
                         </div>
                       </div>
                     </div>
                     <div className='sweetness-col'>
                       <h4 className='acidity-header' style={{ fontFamily: fontMapBold[sparklingHeaderText] }}>Sweetness</h4>
                       <div className='sweetness-bar'>
                         <div style={{
                           height: '55%',
                           width: `${userSweetness}%`,
                           backgroundColor: barColor[sparklingData?.data?.theme],
                           borderRadius: '20vw',
                           marginLeft: '3%',
                           marginRight: '3%'
                         }}>
                         </div>
                       </div>
                       <div className='acid-label-columns'>
                         <div className='l-acid-col'>
                           <p className='low-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>Dry</p>
                         </div>
                         <div className='r-acid-col'>
                           <p className='high-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>Very Sweet</p>
                         </div>
                       </div>
                     </div>
                   </div>
                   <div className='acid-sweetness-columns effervescence-column'>
                   <div className='acidity-col'>
                     <h4 className='acidity-header' style={{ fontFamily: fontMapReg[sparklingHeaderText] }}>Effervescence</h4>
                     <div className='acidity-bar'>
                       <div style={{
                         height: '55%',
                         width: `${effervescence}%`,
                         backgroundColor: barColor[sparklingData?.data?.theme],
                         borderRadius: '20vw',
                         marginLeft: '3%',
                         marginRight: '3%'
                       }}>
                       </div>
                     </div>
                     <div className='acid-label-columns'>
                       <div className='l-acid-col'>
                         <p className='low-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>Low</p>
                       </div>
                       <div className='r-acid-col'>
                         <p className='high-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>High</p>
                       </div>
                     </div>
                   </div>
                 </div>
                 </div>
               </div>
               <div className='r-col'>
                 <div className='profile-container'>
                   <h2 className='my-profile-header' style={{ fontFamily: fontMapBold[sparklingHeaderText] }}>{wineData?.data?.name} Profile</h2>
                   <p className="user-profile" style={{ fontFamily: fontMapReg[sparklingBodyText] }}>{sparklingWineProfile?.data?.description}</p>
                 </div>
                 <h3 className='flavors-header' style={{ fontFamily: fontMapBold[sparklingHeaderText] }}>Flavors</h3>
                 <div>
                   <div className='flavors-container top'>
                     {sparklingFlavor?.data?.map(item => (
                       <div className='flavor-box' >
                         <div className='flav-img-container' style={{ backgroundColor: item.highlight_color }}>
                           <img
                             className='user-flavor-img'
                             key={item.id}
                             src={`${imageBase}${item.image}${imageType}`}
                             alt={`Flavor ${item.Flavors_id}`}
                           />
                         </div>
                         <p className='flavor-title' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>{item.name}</p>
                       </div>
                     ))}
                   </div>
                 </div>
                 <div className='acid-sweetness-columns'>
                   <div className='acidity-col'>
                     <h4 className='acidity-header' style={{ fontFamily: fontMapBold[sparklingHeaderText] }}>Acidity</h4>
                     <div className='acidity-bar'>
                       <div style={{
                         height: '55%',
                         width: `${acidityPercent}%`,
                         backgroundColor: barColor[sparklingData?.data?.theme],
                         borderRadius: '20vw',
                         marginLeft: '3%',
                         marginRight: '3%'
                       }}>
                       </div>
                     </div>
                     <div className='acid-label-columns'>
                       <div className='l-acid-col'>
                         <p className='low-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>Low</p>
                       </div>
                       <div className='r-acid-col'>
                         <p className='high-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>High</p>
                       </div>
                     </div>
                   </div>
                   <div className='sweetness-col'>
                     <h4 className='acidity-header' style={{ fontFamily: fontMapBold[sparklingHeaderText] }}>Sweetness</h4>
                     <div className='sweetness-bar'>
                       <div style={{
                         height: '55%',
                         width: `${sweetnessPercent}%`,
                         backgroundColor: barColor[sparklingData?.data?.theme],
                         borderRadius: '20vw',
                         marginLeft: '3%',
                         marginRight: '3%'
                       }}>
                       </div>
                     </div>
                     <div className='acid-label-columns'>
                       <div className='l-acid-col'>
                         <p className='low-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>Dry</p>
                       </div>
                       <div className='r-acid-col'>
                         <p className='high-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>Very Sweet</p>
                       </div>
                     </div>
                   </div>
                 </div>
                 <div className='acid-sweetness-columns effervescence-column'>
                   <div className='acidity-col'>
                     <h4 className='acidity-header' style={{ fontFamily: fontMapBold[sparklingHeaderText] }}>Effervescence</h4>
                     <div className='acidity-bar'>
                       <div style={{
                         height: '55%',
                         width: `${effervescencePercent}%`,
                         backgroundColor: barColor[sparklingData?.data?.theme],
                         borderRadius: '20vw',
                         marginLeft: '3%',
                         marginRight: '3%'
                       }}>
                       </div>
                     </div>
                     <div className='acid-label-columns'>
                       <div className='l-acid-col'>
                         <p className='low-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>Low</p>
                       </div>
                       <div className='r-acid-col'>
                         <p className='high-lable' style={{ fontFamily: fontMapReg[sparklingBodyText] }}>High</p>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
         </div>

         </div>
        </div>    
    </div>
  )
}
